import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  createGooglePlan,
  updateGooglePlan,
  fetchGooglePlanById,
} from "./googlePlanService";
import "./GooglePlanFormPage.css";

const isDev = process.env.NODE_ENV === "development";

const GooglePlanFormPage = () => {
  const { planId, googlePlanId } = useParams();
  const navigate = useNavigate();

  const isEdit = Boolean(googlePlanId);

  const [formData, setFormData] = useState({
    productId: "",
    basePlanId: "",
    offerId: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isEdit) {
      loadGooglePlan();
    }
  }, []);

  const loadGooglePlan = async () => {
    try {
      const response = await fetchGooglePlanById(googlePlanId);

      if (isDev) console.log("Edit Data:", response.data);

      setFormData({
        productId: response.data.productId || "",
        basePlanId: response.data.basePlanId || "",
        offerId: response.data.offerId || "",
      });
    } catch (error) {
      if (isDev) console.error("Error loading plan:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isEdit) {
        await updateGooglePlan(googlePlanId, formData);
      } else {
        await createGooglePlan(planId, formData);
      }

      navigate(-1);
    } catch (error) {
      if (isDev) console.error("Save failed:", error);
      alert("Error saving Google Plan");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="google-plan-form-container">
      <h2>{isEdit ? "Edit Google Plan" : "Add Google Plan"}</h2>

      <form onSubmit={handleSubmit} className="google-plan-form">
        <div className="form-group">
          <label>Product ID *</label>
          <input
            type="text"
            name="productId"
            value={formData.productId}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Base Plan ID *</label>
          <input
            type="text"
            name="basePlanId"
            value={formData.basePlanId}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Offer ID (Optional)</label>
          <input
            type="text"
            name="offerId"
            value={formData.offerId}
            onChange={handleChange}
          />
        </div>

        <div className="form-actions">
          <button
            type="button"
            className="cancel-btn"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>

          <button type="submit" className="save-btn" disabled={loading}>
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default GooglePlanFormPage;